import { IAppState } from '../../redux';
import { EOfferStatus } from '../../redux/reducers';

export function selectOfferStatus(state: IAppState): EOfferStatus {
  return state.offer.status;
}
